import { format } from 'date-fns';
import { TimePicker } from '@crono-one/design-system';

export interface TimeOfDayPickerProps {
  value: Date;
  onChange: (newValue: Date) => void;
  disabled?: boolean;
  className?: string;
  contentClassName?: string;
  positionerClassname?: string;
}

/**
 * Thin wrapper around the design-system `TimePicker`, which only speaks
 * "HH:mm" strings, so callers can work with a plain `Date` on both ends.
 */
const TimeOfDayPicker = ({
  value,
  onChange,
  disabled,
  className,
  contentClassName,
  positionerClassname,
}: TimeOfDayPickerProps) => {
  const currentTime = format(value, 'HH:mm');

  return (
    <TimePicker
      variant="text"
      showTrigger={false}
      value={currentTime}
      onValueChange={(newTime) => {
        if (!newTime || newTime === currentTime) return;

        const [hours, minutes] = newTime.split(':').map(Number);
        const newValue = new Date(value);
        newValue.setHours(hours, minutes, 0, 0);

        onChange(newValue);
      }}
      disabled={disabled}
      className={className}
      contentClassName={contentClassName}
      positionerClassname={positionerClassname}
    />
  );
};

export default TimeOfDayPicker;
